const ɵ0 = { scope: "toolbar" };
export class RouteHandlerModule {
}
export { ɵ0 };
